





























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
  getdatalist,
  adduser,
  getuserinfodata,
  changestate,
  getorglist,
  getSideWaylist,
  getorginizlist,
  // checktissueishave,
} from "@/api/adminmanage";
import { resolve } from "dns";
import { kMaxLength } from "buffer";
import { log } from "util";

@Component({
  name: "adminManage",
  components: { Pagination },
})
export default class extends Vue {
  mounted() {
    this.getlist(this.listQuery);
    this.getSession();
  }

  private loading = true;
  private fileSizeIsSatisfy = [];
  private tableData: Array<any> = []; //表格数据
  private total: number = 0;
  private copepsd = "";
  private currtentpage = 1;
  private paramisuse = "";
  private paramusertype = "";
  private caseisshow = true;
  private siderquery = {
    createid: "",
    isuse: 2,
    limit: 10,
    name: "",
    page: 1,
    usertype: "",
  };
  // 分页请求参数
  private listQuery = {
    name: "",
    page: 1,
    limit: 10,
    isuse: 2,
    usertype: "",
    createid: "",
    organid: "",
  };
  //添加表单参数
  private addParms: any = {
    username: "",
    loginname: "",
    psd: "",
    isuse: 1,
    admincode: "",
    orgnizeid: [],
    createid: "",
    usertype: "",
    sex: "",
    age: "",
    copesd: "",
  };
  private editParms: any = {};
  //模态框参数
  private diaparms = {
    dialogVisible: false,
    title: "",
    label: "",
    radio: 0,
    type: "",
    disabled: true,
    diaupload: false,
  };
  private searchOptions: any = [];
  private options: any = [];
  private orgnaztype: any = []; //Cascader组件绑定数据源
  private isResourceshow = 0;
  private multipleSelection = [];
  private state = [
    { name: "启用", value: 1 },
    { name: "禁用", value: 0 },
  ];
  private sexoptions = [
    {
      label: "男",
      value: 0,
    },
    {
      label: "女",
      value: 1,
    },
    {
      label: "性别不详",
      value: 3,
    },
  ];
  // 自定义校验规则
  validatePass2(rule, value, callback) {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.addParms.psd) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  }
  // 校验规则
  private rules = {
    loginname: [{ required: true, message: "请输入登录名", trigger: "blur" }],
    usertype: [{ required: true, message: "请选择角色", trigger: "change" }],
    userorgizetype: [
      { required: true, message: "请选择角色类型", trigger: "change" },
    ],

    orgnizeid: [
      { required: true, message: "请选择所属关系", trigger: "change" },
    ],
    admincode: [
      { required: true, message: "请填写证件号码", trigger: "blur" },
      {
        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
        message: "证件号码格式有误！",
        trigger: "blur",
      },
    ],
    username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
    psd: [
      { required: true, message: "请输入密码", trigger: "blur" },
      { min: 1, message: "密码最少大于1位", trigger: "blur" },
    ],
    copesd: [
      {
        required: true,
        validator: this.validatePass2,
        trigger: "blur",
      },
    ],
  };

  private searchData() {
    if (this.paramusertype === "") {
      // 角色下拉框绑定值为空时候，调用列表接口下usertype管辖下得数据
      this.getlist(this.listQuery);
    } else {
      // 角色下拉框绑定值存在时候，调用列表接口下usertype平级下得数据
      this.getSideWaylist(this.listQuery);
    }
  }
  private clearSearch() {
    if (this.paramusertype === "") {
      // 角色下拉框绑定值为空时候，调用列表接口下usertype管辖下得数据
      this.getlist(this.listQuery);
    } else {
      this.siderquery.usertype = this.paramusertype;
      // 角色下拉框绑定值存在时候，调用列表接口下usertype平级下得数据
      this.getSideWaylist(this.siderquery);
    }
  }
  //
  private getSession() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    this.listQuery.usertype = parma.usertype;
    this.listQuery.createid = parma.createduserid;
    const createdid = parma.createduserid.split(",");
    const orginized = parma.orgnizeid.split(",");
    if (parma.orgnizeid === "0") {
      this.listQuery.organid = "0";
    } else {
      this.listQuery.organid = parma.orgnizeid;
    }
    this.siderquery.createid = parma.createduserid;
    // orginized=0是超级管理员
    if (orginized == 0) {
      // this.diaparms.label = "所属集团军";
      // this.userorgizetype = 2;
      // 列表页得下拉项
      this.searchOptions = [
        {
          value: 1,
          label: "学校管理员",
        },
        {
          value: 2,
          label: "集团军管理员",
        },
        {
          value: 3,
          label: "合成旅管理员",
        },

        // {
        //   value: 4,
        //   label: "营管理员",
        // },
        // {
        //   value: 5,
        //   label: "连管理员",
        // },
      ];
      // 模态框得角色下拉项
    } else if (orginized.length == 1) {
      // 列表页得下拉项
      this.searchOptions = [
        {
          value: 2,
          label: "集团军管理员",
        },
        {
          value: 3,
          label: "合成旅管理员",
        },
      ];
    } else if (orginized.length == 2) {
      // 列表页得下拉项
      this.searchOptions = [
        {
          value: 3,
          label: "合成旅管理员",
        },
      ];
    }
  }
  private getTree(array: any) {
    return array.map((v) => {
      const item: any = {
        value: v.id, //这是创建的新对象 根据需要的键随意更改
        label: v.name,
      };
      if (v.children) item.children = this.getTree(v.children);
      return item;
    });
  }
  // 获取信息列表
  private async getlist(parm: any) {
    let parmjson = sessionStorage.getItem("json");
    let parma: any = null;
    if (parmjson != null) {
      parma = JSON.parse(parmjson);
    }
    await getdatalist(this.listQuery).then((res) => {
      if (res.code === 200) {
        this.loading = false;
        const resdata = res.data.items.tabledata;
        // const resdata = res.data.tabledata;
        resdata.forEach((res: any) => {
          res.isuse = res.isuse == true ? 1 : false;
        });
        this.tableData = resdata;
        this.total = res.data.total;
        // //0为学校管理员 1为集团军管理员
        // this.orgnaztype = res.data.items.orgnazlist;
      }
    });
  }
  // 获取usertype下得平级信息列表
  private async getSideWaylist(param: any) {
    await getSideWaylist(param).then((res) => {
      if (res.code === 200) {
        this.loading = false;
        const resdata = res.data.items.tabledata;
        resdata.forEach((res: any) => {
          res.isuse = res.isuse == true ? 1 : false;
        });
        this.tableData = resdata;
        this.total = res.data.total;
      }
    });
  }
  // 角色下拉框查询时间
  private async changeSelectuser(val: any) {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    this.listQuery.page = 1;
    this.listQuery.limit = 10;
    if (val === "") {
      this.paramusertype = "";
      this.listQuery.usertype = parma.usertype;
      // 获取角色下所管辖得全部数据
      this.getlist(this.listQuery);
    } else {
      this.listQuery.usertype = val;
      this.paramusertype = val;
      // 获取角色得平级数据
      this.getSideWaylist(this.listQuery);
    }
  }
  // 启用状态下拉框查询事件
  private async changeSelectisuse(val) {
    this.listQuery.isuse = val === "" ? 2 : val;
    this.listQuery.page = 1;
    this.listQuery.limit = 10;
    if (this.paramusertype === "") {
      // 角色下拉框绑定值为空时候，调用列表接口下usertype管辖下得数据
      this.getlist(this.listQuery);
    } else {
      // 角色下拉框绑定值存在时候，调用列表接口下usertype平级下得数据
      this.getSideWaylist(this.listQuery);
    }
  }
  // 级联选择器的数据源

  private async showlabel() {
    // this.orgnaztype = [];
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    this.diaparms.disabled = false;
    // 如果是超级管理员登录进来
    if (parma.orgnizeid === "0") {
      // 超级管理员登录时候pid=-1，这里传-1获取到管理员下的所有学校
      const param = {
        id: 0,
      };
      await getorglist(param).then((res: any) => {
        if (res.code === 200) {
          //递归遍历组织树结构
          this.orgnaztype = this.getTree(res.data);
          this.diaparms.disabled = false;
        }
      });
    } else {
      const param = {
        id: parma.orgnizeid.split(",").pop(),
      };
      await getorglist(param).then((res: any) => {
        if (res.code === 200) {
          this.orgnaztype = this.getTree(res.data);
          this.diaparms.disabled = false;
        }
      });
    }
  }
  // 当超级管理员下的角色进来编辑的时候级联选择器
  private async showotherlabel() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    const param = {
      id: parma.orgnizeid.split(",").pop(),
    };
    await getorglist(param).then((res: any) => {
      if (res.code === 200) {
        //递归遍历组织树结构
        this.orgnaztype = this.getTree(res.data);

        this.diaparms.disabled = false;
      }
    });
  }

  // 新增用户
  private adduser() {
    this.diaparms.dialogVisible = true;
    this.editParms = {};
    this.diaparms.title = "新增用户";
    this.orgnaztype = [];
    this.addParms.orgnizeid = "";
    this.diaparms.disabled = true;
    ++this.isResourceshow;
    // this.diaparms.label = "选择组织";
    this.showlabel();
    this.$nextTick(() => {
      (this.$refs.addParms as any).resetFields();
      this.addParms = {
        username: "",
        loginname: "",
        psd: "",
        isuse: 1,
        admincode: "",
        orgnizeid: "",
        usertype: "",
        copesd: "",
      };
    });
  }

  // 上传评分表
  private uploaduserfile() {
    this.diaparms.diaupload = true;
  }
  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  // 导出评分表
  private exportfile() {
    if (this.multipleSelection.length === 0) {
      this.$message.warning("请选择需要导出得考生");
    } else {
      let idarray: any = [];
      this.multipleSelection.forEach((item: any) => {
        idarray.push(item.id);
      });
      const param = {
        idlist: idarray.join(","),
      };
    }
  }
  private resetuser() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    this.paramusertype = "";
    this.paramisuse = "";
    this.listQuery = {
      name: "",
      limit: 10,
      page: 1,
      usertype: "",
      isuse: 2,
      createid: parma.createduserid,
      organid: parma.orgnizeid,
    };
    this.getlist(this.listQuery);
  }
  // 提交表单
  private submit() {
    const form = this.$refs.addParms as any;
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    let that_ = this;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    form.validate(async (valid: boolean) => {
      if (valid) {
        // parma.orgnizeid == 0超级管理员登录
        if (!Array.isArray(this.addParms.orgnizeid)) {
          this.addParms.orgnizeid = this.addParms.orgnizeid.split(",");
        }
        if (parma.orgnizeid == 0) {
          if (this.addParms.orgnizeid.length != this.addParms.usertype) {
            this.$message.warning("管理员角色和所属组织不匹配，请检查后重试");
          } else {
            // id存在编辑，不存在新增
            // svaedata();
          }
        } else if (parma.orgnizeid.split(",").length == 1) {
          if (this.addParms.orgnizeid.length + 1 !== this.addParms.usertype) {
            if (
              this.addParms.orgnizeid.length === 0 &&
              this.addParms.usertype === ""
            ) {
              // svaedata();
            } else {
              this.$message.warning("管理员角色和所属组织不匹配，请检查后重试");
            }
          } else {
            // id存在编辑，不存在新增
            // svaedata();
          }
        } else if (parma.orgnizeid.split(",").length == 2) {
          if (this.addParms.orgnizeid.length + 2 !== this.addParms.usertype) {
            if (
              this.addParms.orgnizeid.length === 0 &&
              this.addParms.usertype === ""
            ) {
              // svaedata();
            } else {
              this.$message.warning("管理员角色和所属组织不匹配，请检查后重试");
            }
          } else {
            // id存在编辑，不存在新增
            // svaedata();
          }
        }
        //保存数据

        // function svaedata() {
        //   // 先判断当前组织上是否已绑定管理员，管理员是唯一得
        //   let newarray = that_.addParms.orgnizeid.concat();
        //   if (!newarray) {
        //     handlesavedata();
        //   } else {
        //     const ishaveuser = {
        //       flag: 0,
        //       id: newarray.pop(),
        //     };
        //     checktissueishave(ishaveuser).then((res) => {
        //       if (res.data === null) {
        //         handlesavedata();
        //       } else {
        //         that_
        //           .$confirm(
        //             "当前组织上已绑定了管理员“" +
        //               res.data +
        //               "”，继续将会导致管理员“" +
        //               res.data +
        //               "”失去管理权限, 是否继续?",
        //             "提示",
        //             {
        //               confirmButtonText: "确定",
        //               cancelButtonText: "取消",
        //               type: "warning",
        //             }
        //           )
        //           .then(async () => {
        //             handlesavedata();
        //           })
        //           .catch(() => {});
        //       }
        //     });
        //   }

        //   function handlesavedata() {
        //     console.log(that_.addParms.id != undefined);
        //     if (that_.addParms.id != undefined) {
        //       that_.editParms = {
        //         username: that_.addParms.username,
        //         loginname: that_.addParms.loginname,
        //         psd: that_.addParms.psd,
        //         isuse: that_.addParms.isuse,
        //         admincode: that_.addParms.admincode,

        //         usertype: that_.addParms.usertype,
        //         sex: that_.addParms.sex,
        //         age: that_.addParms.age,
        //         id: that_.addParms.id,
        //         isdelete: 1,
        //       };
        //       if (parma.orgnizeid == 0) {
        //         that_.editParms.orgnizeid = that_.addParms.orgnizeid.join(",");
        //       } else {
        //         that_.editParms.orgnizeid =
        //           parma.orgnizeid + "," + that_.addParms.orgnizeid;
        //       }

        //       changestate(that_.editParms).then((res: any) => {
        //         // console.log(1);
        //         if (res.code === 200) {
        //           that_.$message({
        //             message: "成功",
        //             type: "success",
        //           });
        //           form.resetFields();
        //           that_.diaparms.dialogVisible = false;
        //           that_.emptyParms();
        //           that_.getlist(that_.listQuery);
        //         } else if (res.code === 201) {
        //           that_.$message({
        //             message: "该用户已存在，请勿重复添加",
        //             type: "warning",
        //           });
        //         }
        //       });
        //     } else {
        //       if (parma.orgnizeid != 0) {
        //         that_.addParms.orgnizeid =
        //           parma.orgnizeid + "," + that_.addParms.orgnizeid.toString();
        //       } else {
        //         that_.addParms.orgnizeid = that_.addParms.orgnizeid.toString();
        //       }
        //       that_.addParms.createid = parma.createduserid;
        //       let addparams = {
        //         admincode: that_.addParms.admincode,
        //         age: that_.addParms.age,
        //         createid: that_.addParms.createid,
        //         isuse: that_.addParms.isuse,
        //         loginname: that_.addParms.loginname,
        //         orgnizeid: that_.addParms.orgnizeid,
        //         psd: that_.addParms.psd,
        //         sex: that_.addParms.sex,
        //         username: that_.addParms.username,
        //         usertype: that_.addParms.usertype,
        //       };
        //       adduser(addparams).then((res: any) => {
        //         if (res.code === 200) {
        //           that_.$message({
        //             message: "成功",
        //             type: "success",
        //           });
        //           form.resetFields();
        //           that_.diaparms.dialogVisible = false;
        //           that_.copepsd = "";
        //           that_.getlist(that_.listQuery);
        //         } else if (res.code === 201) {
        //           that_.$message({
        //             message: "身份证号或者登录名不能重复",
        //             type: "warning",
        //           });
        //         }
        //       });
        //     }
        //   }
        // }
      }
    });
  }
  //编辑用户
  private async editinfo(parms: any) {
    this.diaparms.title = "编辑用户";
    this.diaparms.disabled = false;
    this.orgnaztype = [];
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    /*
      如果超级管理员登录，级联选择器数据源选择超级管理员建的所有的组织
      其他角色登录，级联选择器数据源绑定的是角色对应的组织树结构
    */
    if (parma.orgnizeid == 0) {
      this.showlabel();
    } else {
      this.showotherlabel();
    }
    ++this.isResourceshow;

    const param = {
      id: parms.id,
      // usertype: this.listQuery.usertype,
    };
    // this.caseisshow = false;
    await getuserinfodata(param).then((res) => {
      // this.caseisshow = false;
      if (res.code === 200) {
        // 调用递归方法生成el-cascader组件回显数据需要的格式
        let data = res.data.items;
        this.handleProps(data.organItemList);
        if (data.organItemList.length === 0) {
          data.usertype = "";
        } else if (data.organItemList.length === 1) {
          data.usertype = 1;
        } else if (data.organItemList.length === 2) {
          data.usertype = 2;
        } else if (data.organItemList.length === 3) {
          data.usertype = 3;
        }
        let caseidlist: any = [];
        data.organItemList.forEach((e) => {
          caseidlist.push(e.organId);
        });
        if (parma.orgnizeid == 0) {
          caseidlist.join(",");
        } else {
          caseidlist.splice(0, 1).join(",");
        }

        this.addParms = {
          username: data.username,
          loginname: data.loginname,
          psd: data.psd,
          isuse: data.isuse,
          admincode: data.admincode,
          orgnizeid: caseidlist,
          usertype: data.usertype,
          sex: data.sex,
          age: data.age,
          id: data.id,
          copesd: data.psd,
        };

        this.diaparms.dialogVisible = true;
      }
    });
  }
  // 递归处理cascader绑定数据源，回显数据
  private handleProps(arr: any) {
    const result = {};
    let cur: any = result;
    arr.forEach((item, index) => {
      cur.label = item.organName;
      cur.value = item.organId;
      if (index !== arr.length - 1) {
        cur.children = [{}];
        cur = cur.children[0];
      }
    });
    this.orgnaztype.push(result);
  }
  private aa(item: any) {}
  //删除用户
  private removeuser(parm: any) {
    this.$confirm("确认要删除用户吗？", "删除用户", {
      type: "warning",
    }).then(async () => {
      const params = {
        admincode: parm.admincode,
        age: parm.age,
        createid: parm.createduserid,
        id: parm.id,
        isdelete: 0,
        isuse: parm.isuse,
        loginname: parm.loginname,
        orgnizeid: parm.orgnizeid,
        psd: parm.psd,
        sex: parm.sex,
        username: parm.psd,
        usertype: parm.usertype,
      };
      await changestate(params).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.searchData();
          this.emptyParms();
        } else {
          this.$message({
            message: "状态更改失败",
            type: "error",
          });
        }
      });
    });
  }

  private emptyParms() {
    this.addParms = {
      username: "",
      loginname: "",
      psd: "",
      isuse: 1,
      admincode: "",
      orgnizeid: "",
      usertype: "",
      copepsd: "",
    };
    this.editParms = {
      isdelete: "",
      username: "",
      loginname: "",
      name: "",
      psd: "",
      isuse: 1,
      admincode: "",
      orgnizeid: "",
      usertype: "",
    };
  }

  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getlist(this.listQuery);
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getlist(this.listQuery);
  }
  // 更改角色使用状态
  private async changeSwitch(parm: any) {
    this.editParms = parm;
    this.editParms.isdelete = 1;
    await changestate(this.editParms).then((res) => {
      if (res.code === 200) {
        this.$message({
          message: "状态更改成功",
          type: "success",
        });
        this.emptyParms();
        if (this.paramusertype === "") {
          // 角色下拉框绑定值为空时候，调用列表接口下usertype管辖下得数据
          this.getlist(this.listQuery);
        } else {
          // 角色下拉框绑定值存在时候，调用列表接口下usertype平级下得数据
          this.getSideWaylist(this.listQuery);
        }
      } else {
        this.$message({
          message: "状态更改失败",
          type: "error",
        });
      }
    });
  }
  // 模态框关闭
  private handleClose(done: any) {
    this.diaparms.dialogVisible = false;
    this.$nextTick(() => {
      (this.$refs.addParms as any).resetFields();
    });
  }
  // 设置表格字体居中
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
}
